import { render, staticRenderFns } from "./OverlayThumbnail.vue?vue&type=template&id=58bccb02&scoped=true&"
import script from "./OverlayThumbnail.vue?vue&type=script&lang=js&"
export * from "./OverlayThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./OverlayThumbnail.vue?vue&type=style&index=0&id=58bccb02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bccb02",
  null
  
)

export default component.exports